app.controller('OrderQuoteEndController', ['$rootScope', '$scope', '$stateParams', '$state', function ($rootScope, $scope, $stateParams, $state) {

    $scope.order_id = $stateParams.order_id ? $stateParams.order_id : $rootScope.model.order.current_order._id;
    $scope.waiting_for_data = $scope.order_id;
    let visibleQuote = null;
    $scope.visible_quote = null;
    $scope.wrong_order_mode = false;

    const standardDeliveryType = {
        id: "standard",
        disabled: false
    }

    const twoPersonDeliveryType = {
        id: "two_person_delivery",
        disabled: false
    }

    const collectionDeliveryType = {
        id: "collection",
        disabled: false
    }

    $scope.webquote_defaults = {}
    $scope.postcode_error = null;

    $scope.delivery_types = [standardDeliveryType, twoPersonDeliveryType, collectionDeliveryType];

    $scope.view_model = {
        delivery_type_id: "standard",
        do_show_edit_order_ref: false,
        show_printable_logo: true,
        include_carriage_price: false
    }

    if ($scope.waiting_for_data) {
        $rootScope.service.account.requireMinimumData(function () {
            $scope.webquote_defaults = $rootScope.model.account.user_data.webquote_defaults ? $rootScope.model.account.user_data.webquote_defaults : {}
            $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {
                console.log(order)
                if (success) {
                    $scope.waiting_for_data = false;
                    const isOrderQuote = $rootScope.service.order_helper.isOrderQuote(order);
                    if (isOrderQuote) {
                        applyQuote(order);
                        $scope.view_model.include_carriage_price = isDeliverySelected();
                        $scope.validateDeliveryPerson();
                    } else {
                        $scope.wrong_order_mode = true;
                    }
                }
            })
        });
    }

    $scope.currentDate = function () {
        return new Date();
    }

    $scope.getDeliveryAddress = function () {
        visibleQuote.delivery_address = $rootScope.site_helper.requireObject(visibleQuote.delivery_address);
        return visibleQuote.delivery_address;
    }

    $scope.getAddresses = function () {
        return !$rootScope.model.staff.is_staff_or_rep ? $rootScope.model.account.user_data.addresses : $rootScope.model.account.customer_data.addresses;
    }

    function isDeliverySelected() {
        if (visibleQuote.delivery_address && (visibleQuote.delivery_address.postcode || visibleQuote.delivery_address.country)) {
            return true;
        }
        if (visibleQuote.two_person_delivery) {
            return true;
        }
        return visibleQuote.collection;

    }

    $scope.onIncludeCarriagePriceChange = function () {
        if (!$scope.view_model.include_carriage_price) {
            if (isDeliverySelected()) {
                delete visibleQuote.delivery_address;
                $scope.view_model.delivery_type_id = "standard";
                $scope.saveOrder();
            }
        }
    }

    $scope.exportExcel = function () {
        const tableID = "quote_overview_table";
        const table = document.getElementById(tableID);
        const reference = visibleQuote.reference ? visibleQuote.reference : visibleQuote._id;
        const fileName = $rootScope.site_helper.slugify("Quote " + reference)
        $rootScope.site_helper.exportExcelTable(table, fileName);
    }

    $scope.resumeOrder = function () {

        $rootScope.navigation_manager.requireInitialized(function () {
            const routeOptions = $rootScope.service.order_helper.recentBrowseRoute(visibleQuote);
            if (routeOptions) {
                $state.go(routeOptions.route, routeOptions.options);
                return;
            }
            $state.go('myba.dashboard');
        });
    };

    $scope.validateDeliveryPerson = function () {
        let i, key, deliveryAddress;
        const dummyPersonKeys = ['name', 'address1', 'telephone', 'town', 'county'];
        deliveryAddress = $scope.getDeliveryAddress();

        if (!deliveryAddress.postcode) {
            $scope.postcode_error = "You must enter a Postcode";
            return;
        }

        for (i = 0; i < dummyPersonKeys.length; i++) {
            key = dummyPersonKeys[i];
            let dummyVal = "dummy";
            if (key === "telephone") {
                dummyVal = 12345678
            }
            deliveryAddress[key] = dummyVal;
        }

        $scope.postcode_error = null;


        $scope.saveOrder(function (success, quote, messages) {
            if (!success) {
                return;
            }

            deliveryAddress = $scope.getDeliveryAddress();

            $scope.postcode_error = quote._errors && quote._errors.deliveryAddress ? quote._errors.deliveryAddress : null;
            for (i = 0; i < dummyPersonKeys.length; i++) {
                key = dummyPersonKeys[i];
                delete deliveryAddress[key];
            }
            $scope.saveOrder();
        })
    }


    $scope.saveOrder = function (callback) {
        applyViewModelToQuote();
        $rootScope.service.order.saveOrder(visibleQuote, function (success, quote, messages) {
            if (success) {
                applyQuote(quote);
            }
            if (callback) {
                callback(success, quote, messages);
            }
        })
    };

    function applyQuote(quote) {
        $scope.visible_quote = quote;
        visibleQuote = $scope.visible_quote;

        if (visibleQuote.collection) {
            $scope.view_model.delivery_type_id = "collection"
        } else if (visibleQuote.two_person_delivery) {
            $scope.view_model.delivery_type_id = "two_person_delivery"
        } else {
            $scope.view_model.delivery_type_id = "standard"
        }

        twoPersonDeliveryType.disabled = !visibleQuote._allow_two_person_delivery;
        collectionDeliveryType.disabled = !visibleQuote._collectible;

        if (($scope.view_model.delivery_type_id === "two_person_delivery" && twoPersonDeliveryType.disabled) || ($scope.view_model.delivery_type_id === "collection" && collectionDeliveryType.disabled)) {
            $scope.view_model.delivery_type_id = "standard"
        }
        applyViewModelToQuote();

    }

    function applyViewModelToQuote() {
        visibleQuote.collection = $scope.view_model.delivery_type_id === "collection";
        visibleQuote.two_person_delivery = $scope.view_model.delivery_type_id === "two_person_delivery";
    }

    $scope.saveForLater = function () {
        $scope.saveOrder(function () {
            $rootScope.service.order.startNewOrder();
            $state.go('myba.dashboard');
        })
    };

    $scope.quoteSubtotalPrice = function () {
        return visibleQuote._quote_subtotal_price + ($scope.view_model.include_carriage_price ? visibleQuote._carriage_price : 0);
    }

    $scope.quoteVatPrice = function () {
        return visibleQuote._quote_vat_price + ($scope.view_model.include_carriage_price ? Math.round(visibleQuote._carriage_price * (visibleQuote._quote_vat_rate / 100)) : 0);
    }

    $scope.quoteTotalPrice = function () {
        return $scope.quoteSubtotalPrice() + $scope.quoteVatPrice();
    }

    $scope.getSublines = function (quoteLine) {
        const lines = [];
        if (!quoteLine || !quoteLine._sublines) {
            return [];
        }
        for (let i = 0; i < quoteLine._sublines.length; i++) {
            const line = quoteLine._sublines[i];
            line.dash = quoteLine.dash ? quoteLine.dash + "-" : "-";
            lines.push(line);
            const childLines = $scope.getSublines(line);
            for (let j = 0; j < childLines.length; j++) {
                lines.push(childLines[j]);
            }
        }
        return lines;
    }

    $scope.convertQuoteToOrder = function () {
        $rootScope.service.order_quote.convertQuoteToOrder(visibleQuote, function (success, order, messages) {
            if (order) {
                $rootScope.service.order.setCurrentOrder(order);
                $rootScope.service.staff.requireCurrentOrderCustomer(function () {
                    $rootScope.service.tracking.track_event("Checkout", "Started from saved quote");
                    $state.go('myba.order-checkout.review');
                });
            } else {
                $state.go('myba.dashboard');
            }

        });
    }

    $scope.averageMargin = function () {
        if (!visibleQuote || !visibleQuote.lines || !visibleQuote.lines.length) {
            return 0;
        }
        let total = 0;
        for (let i = 0; i < visibleQuote.lines.length; i++) {
            const line = visibleQuote.lines[i];
            total += line.quote_margin ? line.quote_margin : 0;
        }
        return Math.round(total / visibleQuote.lines.length);
    }

    $scope.averageDiscount = function () {
        if (!visibleQuote || !visibleQuote.lines || !visibleQuote.lines.length) {
            return 0;
        }
        if (!visibleQuote || !visibleQuote.lines || !visibleQuote.lines.length) {
            return 0;
        }
        let total = 0;
        for (let i = 0; i < visibleQuote.lines.length; i++) {
            const line = visibleQuote.lines[i];
            total += line.quote_discount ? line.quote_discount : 0;
        }
        return Math.round(total / visibleQuote.lines.length);
    }

    $scope.startNewOrder = function () {
        $rootScope.service.order.startNewOrder();
        $state.go('myba.dashboard');
    }

}]);